import { fetchJSON } from "../framework/api";

function syncSubsessionSections(evaluationId, value) {
  document.querySelectorAll(`[data-js-per-subsession-listener="${evaluationId}"]`).forEach((listener) => {
    listener.querySelectorAll("[data-js-per-subsession-show]").forEach((el) => {
      const showWhen = el.dataset.jsPerSubsessionShow;
      if (showWhen === "session") {
        el.hidden = value;
      } else if (showWhen === "subsession") {
        el.hidden = !value;
      }
    });
  });
}

// Toggle radio buttons — PUT then sync visible sections
document.addEventListener("change", async (e) => {
  const radio = e.target;
  if (radio.type !== "radio") return;

  const container = radio.closest("[data-js-subsession-toggle]");
  if (!container) return;

  const evaluationId = container.dataset.jsSubsessionToggle;
  const newValue = radio.value === "true";

  if (container.classList.contains("is-loading")) return;

  container.classList.add("is-loading");
  container.querySelectorAll("input[type=radio]").forEach((r) => (r.disabled = true));

  try {
    await fetchJSON(p`/ajax/evaluations/${evaluationId}`, {
      method: "PUT",
      body: { evaluation: { one_form_per_subsession: newValue } },
    });

    container.querySelectorAll("input[type=radio]").forEach((r) => {
      r.checked = r.value === String(newValue);
    });

    syncSubsessionSections(parseInt(evaluationId, 10), newValue);
  } catch (error) {
    console.error("Error while updating one_form_per_subsession", error);
  } finally {
    container.classList.remove("is-loading");
    // WHY: if we got here, evaluation was not resolved (resolved radios are disabled and skip the handler)
    container.querySelectorAll("input[type=radio]").forEach((r) => (r.disabled = false));
  }
});

// Disable toggle when evaluation becomes resolved (e.g. made visible on extranet)
document.addEventListener("evaluation-resolved", (e) => {
  const { id } = e.detail;

  document.querySelectorAll(`[data-js-subsession-toggle="${id}"] input[type=radio]`).forEach((r) => {
    r.disabled = true;
  });
});

// Subsession tabs
document.addEventListener("click", (e) => {
  const tab = e.target.closest("[data-js-subsession-tab]");
  if (!tab) return;

  const container = tab.closest("[data-js-subsession-tabs]");
  if (!container) return;

  const subsessionId = tab.dataset.jsSubsessionTab;

  container.querySelectorAll("[data-js-subsession-tab]").forEach((t) => {
    t.classList.toggle("tab__item--active", t.dataset.jsSubsessionTab === subsessionId);
  });

  container.querySelectorAll("[data-js-subsession-panel]").forEach((panel) => {
    panel.hidden = panel.dataset.jsSubsessionPanel !== subsessionId;
  });
});
